import React, { Component } from 'react';
import CheckBox from '../../../../../../components/ZUILib/CheckBox';
import commonUtil from '../../../../../../utils/commonUtil';

export default class AddressDetails extends Component {
  constructor() {
    super();
    this.days = [];
    this.addChildControlRef = this.addChildControlRef.bind(this);
    this.getOptedDays = this.getOptedDays.bind(this);
  }
  reset() {
    this.days.forEach((day, index) => {
      day.setChecked(this.props.address.delieveryDaysInfo[index].opted);
    });
  }

  getOptedDays() {
    const opted = [];
    this.days.forEach((day, index) => {
      const data = this.props.address.delieveryDaysInfo[index];
      data.opted = day.isChecked();
      opted.push(data);
    });
    return opted;
  }

  addChildControlRef(childControl) {
    if (childControl === null) {
      return;
    }
    let itemAdded = false;
    this.days.forEach((child) => {
      if (child.props.id === childControl.props.id) {
        itemAdded = true;
      }
    });
    if (this.days.length < 1 || !itemAdded) {
      this.days.push(childControl);
    }
  }

  render() {
    const address = this.props.address;
    let adminName = ' ';
    if (address.firstName) {
      adminName += commonUtil.sentenceCase(address.firstName);
    }
    if (address.motherName) {
      adminName += ' ' + commonUtil.sentenceCase(address.motherName);
    }
    if (address.lastName) {
      adminName += ' ' + commonUtil.sentenceCase(address.lastName);
    }
    let addressDataHtml = ' ';
    if (address.address1) {
      addressDataHtml += ' ' + commonUtil.sentenceCase(address.address1);
    }
    if (address.exteriorNumber) {
      addressDataHtml += ', Ext. ' + commonUtil.sentenceCase(address.exteriorNumber);
    }
    if (address.interiorNumber) {
      addressDataHtml += ', Int. ' + commonUtil.sentenceCase(address.interiorNumber);
    }
    if (address.building) {
      addressDataHtml += ', ' + commonUtil.sentenceCase(address.building);
    }
    if (address.city) {
      addressDataHtml += ', ' + commonUtil.sentenceCase(address.city);
    }
    if (address.colony) {
      addressDataHtml += ', ' + commonUtil.sentenceCase(address.colony);
    }
    if (address.delegationMunicipality) {
      addressDataHtml += ', ' + commonUtil.sentenceCase(address.delegationMunicipality);
    }
    if (address.postalCode) {
      addressDataHtml += ', ' + address.postalCode;
    }
    if (address.state) {
      addressDataHtml += ', ' + commonUtil.sentenceCase(address.state);
    }
    if (address.address2) {
      addressDataHtml += ', ' + commonUtil.sentenceCase(address.address2);
    }
    if (address.phoneNumber) {
      addressDataHtml += ', ' + address.particularPhoneCode + address.phoneNumber;
    }
    return (
      <div className="col-sm-4 giftPA">
        <h3 className="giftPAName">{this.props.address.nickName}</h3>
        <span className="giftPAAdmin">{adminName}</span>
        <address>{addressDataHtml}</address>
        <ul className="selectDayList">
          {this.props.address.delieveryDaysInfo.length > 0 ? this.props.address.delieveryDaysInfo.map((currentAddress, index) =>
            <li>
              <CheckBox
                key={index}
                defaultChecked={currentAddress.opted}
                changeOnPropsChange="true"
                id={currentAddress.deliveryDay + '_' + this.props.address.addressId}  // given the different id for both address
                value={currentAddress.deliveryDay}
                displayName={currentAddress.deliveryDay}
                getSelectedValue={this.props.changeAddressDeliveryPreference}
                ref={(el) => { this.addChildControlRef(el); }}
                disabled={this.props.eventStatusForSuspended && 'disabled'}
              />
            </li>) : <span>{this.props.address.message}</span>}
        </ul>
      </div>
    );
  }
}

